<template>
	<component :key="alertId" v-if="alert && alertHandlerComponent" :is="alertHandlerComponent" :alert="alert" />
</template>
<script>
import { getAlert } from '@/store/modules/alerts/getters';
import { getAlert as useAlert } from '@/store/modules/alerts/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { ALERT_HANDLERS_COMPONENTS } from '@/components/Alerts/AlertTypes/AlertTypes.const.js';
export default {
	name: 'InAppAlertRun',
	props: { alertId: { type: Number } },
	computed: {
		...mapGettersShorthand({ useAlert }),
		alert() {
			return this.useAlert(this.alertId);
		},
		alertHandlerComponent() {
			return ALERT_HANDLERS_COMPONENTS[this.alert.action_type];
		},
	},
	methods: { ...mapActionsShorthand({ getAlert }) },
	watch: {
		alertId: {
			handler(id) {
				if (!this.alert) {
					this.getAlert({ id });
				}
			},
			immediate: true,
		},
	},
};
</script>
<style scoped lang="scss"></style>
